/**
 * Set the browser's title in a consistent format.
 *
 * @param {String} title Title to set.
 */
export default function setBrowserTitle(title) {
  document.title = nbc.browserTitle.replace('%s', title);
}
